<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item style="margin-left:22px;">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="filters.workName"
        placeholder="作业名称"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-right: 0px;">
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn
  },
  data() {
    return {
      size: "small",
      filters: {},
      displayData: []
    };
  },
  created() {},
  methods: {
    initData() {
      //查询
      this.$emit("search", this.filters);
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", this.filters);
    }
  }
};
</script>
